<template>
    <div >
		<TicketPacking :baseURL='baseURL' :qiybh="qiybh" :userName="userName" @forkhzsj="forkhzsj" @getFpdata="getFpdata"></TicketPacking>

    <!-- 预览框 -->
    <Billingcomponent :outerVisible="outerVisible" @closeouterVisible="closeouterVisible"
			:ruleFormb="allitem.ruleFormb" :priceall="allitem.priceall" :totalall="allitem.totalall"
			:ruleFormbxiao="allitem.ruleFormbxiao" :form_chae="allitem.form_chae" :bztext="allitem.bztext"
			:stateall="allitem.stateall" :listoflists="allitem.listoflists" :invoiceNo="allitem.invoiceNo"
			:invoiceCode="allitem.invoiceCode" :billingDate="allitem.billingDate" title="预览发票"
			:documentStatus="allitem.documentStatus" :checkCode="allitem.checkCode"></Billingcomponent>
    </div>
</template>
<script>
import config from '../../../../configHttp.js'
  export default {
    components: {
     
    },
     created() {
     		  if(localStorage.getItem('useropj')){
     			  var useropj=JSON.parse(localStorage.getItem('useropj'))
     			  this.baseURL=config.baseExpressURL
     			  this.qiybh=useropj.currCompany.code
     			  this.userName=useropj.userName
     		  }
     		
     },
  
    data(){
      return{
        baseURL:"",
        qiybh:"",
		    userName:"",
        //预览框：
        outerVisible: false,
        allitem: {},
        sdsHeatSensitivePaperManageQueryparams: {
          orgCode:[]
        },
        sdsHeatSensitivePaperManageQueryparamJSON:"",
        showcompents:false
      }
    },
	methods: {
			forkhzsj(){
					this.$router.push("/Customermasterdata")
				},
        getFpdata(data){
          this.allitem = data;
          if (this.allitem.stateall&&this.allitem.stateall.istaxincluded) {
            if(this.notemptyandnull(this.allitem.priceall)){
            this.allitem.priceall.forEach(r => {
              r.chooseMoney = r.chooseMoney - r.taxRatemoney;
              if (r.unitPrice) {
                if (r.quantity && r.quantity > 1) {
                  r.unitPrice = (r.unitPrice - (r.taxRatemoney / r.quantity)).toFixed(2);
                } else {
                  r.unitPrice = r.unitPrice - r.taxRatemoney;
                }
              }
            })	
            }
          }
				this.outerVisible = true;
      },
      closeouterVisible() {
				this.outerVisible = false;
			}
	},
  };
</script>
<style  scoped="scoped">

</style>